module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', {
    staticClass: "do-tbody"
  }, [_c('tr', {
    staticClass: "calendar-header"
  }, [_c('td', [_c('div', {
    staticClass: "calendar-header__title"
  }, [_c('DDropdown', [_c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.$emit('createSubject', {
          calendar: _vm.calendar,
          users: _vm.users
        })
      }
    }
  }, [_vm._v("\n            Tilføj person til stue\n          ")])])]), _vm._v("\n      " + _vm._s(_vm.calendar.name) + "\n    ")], 1)]), _vm._v(" "), _c('td', {
    staticClass: "norm"
  }, [_vm._v("Norm")]), _vm._v(" "), _c('td', {
    staticClass: "norm"
  }, [_vm._v("I ugen")]), _vm._v(" "), _vm._l((_vm.eventsInDays), function(day) {
    return _c('td', {
      key: day.dateId
    }, [_c('div', {
      staticClass: "calendar__header__day"
    }, [_c('div', [_c('DutySchedulePlanCalendarDayStats', {
      attrs: {
        "openingHours": _vm.openingHours,
        "hours": day.v_formattedTime
      }
    })], 1)])])
  })], 2), _vm._v(" "), _vm._l((_vm.usersWithCalc), function(user) {
    return _c('tr', {
      key: ("user-row-" + (user.id)),
      staticClass: "user-row"
    }, [_c('td', [_c('div', {
      staticClass: "user-name"
    }, [_c('DDropdown', {
      staticClass: "title--grey",
      on: {
        "open": function($event) {
          return _vm.readUserSubject(user)
        }
      }
    }, [_c('ul', {
      attrs: {
        "slot": "list"
      },
      slot: "list"
    }, [(_vm.isLoadingTheUserSubject) ? _c('li', [_c('div', {
      staticClass: "do-spinner"
    })]) : _c('li', {
      staticClass: "d-item-warning",
      on: {
        "click": function($event) {
          return _vm.setTheDeleteUser(user)
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    }), _vm._v(" " + _vm._s(_vm.theUserSubject && _vm.theUserSubject.can_delete ? 'Slet' : 'Fjern') + " fra\n            stue\n          ")])])]), _vm._v("\n      " + _vm._s(user.name) + "\n    ")], 1)]), _vm._v(" "), _c('td', {
      staticClass: "norm"
    }, [_vm._v(_vm._s(user.v_employment))]), _vm._v(" "), _c('td', {
      staticClass: "norm"
    }, [_vm._v(_vm._s(user.v_events.v_minutesFormatted))]), _vm._v(" "), _vm._l((_vm.days), function(day) {
      return _c('td', {
        key: ("day-cell-" + (user.id) + "-" + (day.dateFormatted))
      }, [_c('DutyScheduleCalendarUserDay', {
        attrs: {
          "user": user,
          "date": day.date,
          "eventsInHash": _vm.eventsInHash,
          "subjectsInUserCalIdHash": _vm.subjectsInUserCalIdHash,
          "theCreateEventObj": _vm.theCreateEventObj
        },
        on: {
          "createEvent": function($event) {
            return _vm.$emit('createEvent', $event)
          },
          "editEvent": function($event) {
            return _vm.$emit('editEvent', $event)
          }
        }
      })], 1)
    })], 2)
  }), _vm._v(" "), (_vm.theDeleteUser) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isSubmitButtonLoading": _vm.isDeletingUserSubject
    },
    on: {
      "close": function($event) {
        return _vm.setTheDeleteUser(null)
      },
      "confirm": _vm.deleteUserSubject
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-284b8dcf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DutySchedule/DutySchedulePlanCalendar.vue
// module id = 1553
// module chunks = 1